var map = {
	"./404.svg": 33530,
	"./arrow-left.svg": 10474,
	"./arrow-right.svg": 4970,
	"./arrow-top.svg": 10554,
	"./bug.svg": 37130,
	"./chart.svg": 38545,
	"./check-fill.svg": 11133,
	"./check.svg": 99906,
	"./clipboard.svg": 36637,
	"./close.svg": 93318,
	"./component.svg": 2406,
	"./dashboard.svg": 58749,
	"./delete-filling.svg": 60311,
	"./delete.svg": 1949,
	"./documentation.svg": 59607,
	"./download.svg": 64782,
	"./drag.svg": 60224,
	"./edit.svg": 48352,
	"./education.svg": 23085,
	"./email.svg": 51533,
	"./example.svg": 49892,
	"./excel.svg": 99139,
	"./exit-fullscreen.svg": 80871,
	"./eye-open.svg": 14301,
	"./eye.svg": 34986,
	"./feedback.svg": 98037,
	"./form.svg": 74062,
	"./fullscreen.svg": 16286,
	"./guide.svg": 55860,
	"./icon.svg": 69789,
	"./international.svg": 13906,
	"./language.svg": 59424,
	"./link.svg": 14121,
	"./list.svg": 72672,
	"./lock.svg": 96648,
	"./message.svg": 30860,
	"./minus.svg": 9588,
	"./money.svg": 11116,
	"./nested.svg": 91476,
	"./password.svg": 46408,
	"./pdf.svg": 26500,
	"./people.svg": 22011,
	"./peoples.svg": 95765,
	"./play.svg": 18522,
	"./plus.svg": 45407,
	"./position.svg": 18941,
	"./praise-fill.svg": 32505,
	"./praise.svg": 53139,
	"./printer.svg": 22225,
	"./qq.svg": 56869,
	"./search.svg": 42042,
	"./shopping.svg": 68764,
	"./size.svg": 40985,
	"./skill.svg": 78673,
	"./star.svg": 68019,
	"./tab.svg": 90817,
	"./table.svg": 3797,
	"./theme.svg": 60987,
	"./top.svg": 13322,
	"./trash.svg": 29739,
	"./tree-table.svg": 38509,
	"./tree.svg": 40964,
	"./upload.svg": 69794,
	"./user.svg": 30042,
	"./wechat.svg": 70267,
	"./zip.svg": 47276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;